import { Tag } from 'antd';
import cx from 'classnames';
import { TAG_COLORS } from '@gtintel/platform-constants';
const TagOption = props => {
  const {
    tag
  } = props;
  return <Tag color={TAG_COLORS[Number(tag.tag_group_code ?? tag.tag_group)] ?? 'geekblue'} className={cx('knowledge')}>
      {tag.name}
    </Tag>;
};
export default TagOption;